import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-5ec0c151"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: /*#__PURE__*/_normalizeClass(['page', 'default-background', 'app-card', 'breathing-skeleton', 'delayed'])
};
const _hoisted_2 = {
  class: "ion-padding"
};
const _hoisted_3 = {
  class: "ion-padding"
};
import useResponsiveness from '@/composables/global/use-responsiveness';
export default /*#__PURE__*/_defineComponent({
  __name: 'SkeletonPage',
  setup(__props) {
    const {
      mdUp
    } = useResponsiveness();
    return (_ctx, _cache) => {
      const _component_ion_skeleton_text = _resolveComponent("ion-skeleton-text");
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(['block-centered', 'content-max-width', {
          'ion-padding': _unref(mdUp)
        }])
      }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_ion_skeleton_text, {
        class: "skeleton-block"
      }), _createVNode(_component_ion_skeleton_text, {
        class: "skeleton-1"
      }), _createVNode(_component_ion_skeleton_text, {
        class: "skeleton-1"
      }), _createVNode(_component_ion_skeleton_text, {
        class: "skeleton-2"
      })]), _createElementVNode("div", _hoisted_3, [_createVNode(_component_ion_skeleton_text, {
        class: "skeleton-1"
      }), _createVNode(_component_ion_skeleton_text, {
        class: "skeleton-1"
      }), _createVNode(_component_ion_skeleton_text, {
        class: "skeleton-2"
      })])])], 2);
    };
  }
});